<template>
  <v-dialog
    v-model="is_open"
    :fullscreen="$vuetify.breakpoint.mobile"
    :persistent="deleting_batch"
    width="500"
    @click:outside="$emit('delete_closed')"
  >
    <v-card>
      <v-card-title class="font-weight-light red--text">
        Confirm Batch Deletion
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <h5>Are you sure you want to delete this batch?</h5>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          color="red"
          dark
          depressed
          :loading="deleting_batch"
          x-large
          rounded
          @click="delete_batch"
          >Delete Batch
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["deleteDialogOpen", "selected_batch"],
  data() {
    return {
      is_open: false,
      batch_id: null,
      deleting_batch: false,
    };
  },
  watch: {
    deleteDialogOpen(val) {
      this.is_open = val;
    },
    selected_batch(val) {
      if (val) {
        this.batch_id = val.id;
      }
    },
  },
  methods: {

    delete_batch() {
      this.deleting_batch = true;
      axios
        .delete(`/api/item-batches/${this.batch_id}`)
        .then((res) => {
          this.$emit("delete_completed");
        })
        .catch((error) => {})
        .finally(() => {
          this.deleting_batch = false;
        });
    },
  },
};
</script>
